import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { QuarterlyTaxReceiptModel } from './quarterly-tax-receipt.model';
import { QuarterlyTaxReceiptService } from './quarterly-tax-receipt.service';

@Component({
    selector: 'convfact-quarterly-tax-receipt',
    templateUrl: './quarterly-tax-receipt.component.html',
    styleUrls: ['./quarterly-tax-receipt.component.css'],
    standalone: false
})

export class QuarterlyTaxReceiptComponent implements OnInit {

  model = null;

  constructor(
    private quarterlyTaxReceiptService: QuarterlyTaxReceiptService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const uid = params.get('uid');
      if (uid != null) {
        this.quarterlyTaxReceiptService.get(uid).then(quarterlyTaxReceipt => {
          this.model = quarterlyTaxReceipt;
        });
      } else {
        this.model = new QuarterlyTaxReceiptModel;
      }
    });
  }

  saveData(quarterlyTaxReceipt: QuarterlyTaxReceiptModel) {
    if (quarterlyTaxReceipt.uid == null) {
      this.quarterlyTaxReceiptService.add(quarterlyTaxReceipt)
        .then(quarterlyTaxReceipt => {
          this.model = quarterlyTaxReceipt;
          this.returnToIndex();
        }).catch(err => {
          this.displayInfo('Ha ocurrido un error inesperado al crear el stock');
        })
    } else {
      this.quarterlyTaxReceiptService.update(quarterlyTaxReceipt)
        .then(quarterlyTaxReceipt => {
          this.returnToIndex();
        }).catch(err => {
          this.displayInfo('Ha ocurrido un error inesperado al guardar el stock');
        })
    }
  }

  returnToIndex() {
    this.router.navigate(['/taxes/quarter-tax-receipts']);
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
